import { MealsService } from "@/clients/services/MealsService";
import { QueryKeys } from "@/constants/query-keys";
import { QueryStaleTime } from "@/constants/query-stale-time";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

export const useGetYourFood = () => {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: [QueryKeys.YOUR_FOOD],
    staleTime: QueryStaleTime.LONG,
    queryFn: async () => {
      const user = guardGetUserFromLocalStorage();
      const { data } = await MealsService.getYourFoodApiV1MealsYourFoodGet(user.id);
      return data;
    },
  });
  const yourFoodMealsSet = useMemo(() => {
    const mealIdSet = new Set<string>();
    if (!data) {
      return mealIdSet;
    }
    data.breakfast?.forEach((meal) => {
      mealIdSet.add(meal.id ?? "");
    });
    data.lunch?.forEach((meal) => {
      mealIdSet.add(meal.id ?? "");
    });
    data.dinner?.forEach((meal) => {
      mealIdSet.add(meal.id ?? "");
    });
    data.snack?.forEach((meal) => {
      mealIdSet.add(meal.id ?? "");
    });
    return mealIdSet;
  }, [data]);

  return { yourFood: data, yourFoodMealsSet, isLoading, isError, error, refetch };
};
